import { render } from "./TableUi.vue?vue&type=template&id=e835fe16"
import script from "./TableUi.vue?vue&type=script&lang=js"
export * from "./TableUi.vue?vue&type=script&lang=js"

import "./TableUi.vue?vue&type=style&index=0&id=e835fe16&lang=scss"

import exportComponent from "/proyectos/servicios/ide-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__